import { Box, Button, MenuItem, Select, Typography } from '@mui/material';
import { FC } from 'react';
import UserGridSkeleton from './StyledSkeleton';
import { ExpandMoreOutlined } from '@mui/icons-material';

const SkeletonPagination: FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mt={2}
    >
      <Box display="flex" alignItems="center">
        <UserGridSkeleton width="80px" height="10px" />

        <Box
          position="relative"
          sx={{ display: 'inline-block', width: '80px', ml: 1 }}
        >
          <Select
            IconComponent={ExpandMoreOutlined}
            sx={{
              width: '70px',
              height: '25px',
              padding: '1px',
              fontSize: '12px',
              fontWeight: 400,
              fontFamily: 'Outfit',
              color: 'var(--primary-navy)',
              '&:hover': {
                border: 'none',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--border) !important',
              },
              '&:focus-within .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--border) !important',
              },
              '&::-webkit-scrollbar': {
                width: '0px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'var(--primary-blue)',
                borderRadius: '10px',
              },
            }}
          ></Select>
        </Box>
      </Box>

      <Box display="flex" alignItems="center">
        <UserGridSkeleton width="120px" height="10px" />

        <Button
          sx={{
            border: '1px solid',
            borderColor: 'var(--border-blue)',
            ml: 1,
            mr: 1,
            minWidth: '30px',
            color: 'var(--primary-blue)',
            backgroundColor: 'var(--inactive-btn)',
          }}
        >
          <i className="bx bx-chevron-left"></i>
        </Button>

        <Button
          sx={{
            border: '1px solid',
            borderColor: 'var(--border-blue)',
            minWidth: '30px',
            color: 'var(--primary-blue)',
            backgroundColor: 'var(--inactive-btn)',
          }}
        >
          <i className="bx bx-chevron-right"></i>
        </Button>
      </Box>
    </Box>
  );
};

export default SkeletonPagination;
